<template>
  <v-chip
    class='ma-2 w-table-chips'
    :color='color'
    small
    outlined
  >
    <slot name='default' />
  </v-chip>
</template>

<script>
/**
 * @component WorkTableChips
 * @description Chip component for displaying multiple values in table cells.
 * Uses small, colored chip layout.
 *
 * @prop {String} [color='secondary_font_color'] - Chip color.
 *
 * @slot default - Chip content.
 */
export default {
  name: 'WorkTableChips',
  props: {
    color: { type: String, default: 'secondary_font_color' }
  }
};
</script>

<style lang="scss" scoped>
  .v-chip.v-size--small{
    height: 1.25rem !important;
    font-size: 0.875rem  !important;
  }
</style>
